module.exports = __webpack_public_path__ + "static/img/logo.dbe02e0a.png";